var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31.808C11.5547 31.808 7.77667 30.2527 4.666 27.142C1.55533 24.0313 0 20.2533 0 15.808C0 11.756 1.32 8.24267 3.96 5.268C6.6 2.29333 9.86933 0.537333 13.768 0C13.876 0 13.982 0.00400008 14.086 0.0120001C14.19 0.0200001 14.292 0.0313329 14.392 0.0459995C13.7173 0.987333 13.1833 2.034 12.79 3.186C12.3967 4.338 12.2 5.54533 12.2 6.808C12.2 10.364 13.444 13.386 15.932 15.874C18.42 18.362 21.4427 19.6067 25 19.608C26.268 19.608 27.4767 19.4113 28.626 19.018C29.7753 18.6247 30.8073 18.0907 31.722 17.416C31.738 17.516 31.7493 17.618 31.756 17.722C31.7627 17.826 31.7667 17.932 31.768 18.04C31.256 21.9373 29.5127 25.206 26.538 27.846C23.5633 30.486 20.052 31.8067 16 31.808Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.3e38944558aa1d79d508f679e66d3ff8.svg";
export { ForwardRef as ReactComponent };